import { useContext, useState, useMemo, useRef, useEffect } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import { useNavigate, Link } from 'react-router-dom';
import ValidateService from '../../services/ValidateService';
import LoginController from '../../controllers/member/LoginController';

const AdminLogin = () => {
  useEffect(() => {
    document.title = '관리자로그인';
  }, []);
  const { store, updateStore, resetTimer } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const [passwordVisible, setPasswordVisible] = useState(false);

  const naviagte = useNavigate();
  const [valueObj, setValueObj] = useState({
    userType: 'S',
  });
  const [loginMsgDp, setLoginMsgDp] = useState('');

  const controller = useMemo(() => {
    return new LoginController(
      { store, updateStore, resetTimer },
      modalService,
      validateService,
      naviagte,
      {
        valueObj,
        setValueObj,
      },
      {
        loginMsgDp,
        setLoginMsgDp,
      }
    );
  }, [store, modalService, validateService]);

  const togglePasswordVisibility = isVisible => {
    setPasswordVisible(isVisible);
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">관리자로그인</h2>
      </div>
      <div className="tab-area layer">
        <div className="tab line full">
          <ul role="tablist">
            <li
              id="tab_login_01"
              role="tab"
              aria-selected={true}
              className={'active'}
            >
              <button type="button" className="btn-tab">
                관리자 로그인
                <i className="sr-only created">선택됨</i>
              </button>
            </li>
          </ul>
        </div>
        <div className="tab-conts-wrap">
          <section
            id="panel_login_01"
            role="tabpanel"
            aria-labelledby="panel_login_01"
            className="tab-conts active"
          >
            <h3 className="sr-only">시스템관리자 로그인</h3>
            <p className="text-gray-70">
              시스템 관리자를 위한 로그인입니다. <br className="br" />
            </p>
            <div className="login-form-area type-tab">
              <div className="login-wrap">
                <div className="in">
                  <fieldset>
                    <legend>로그인 폼</legend>
                    <div className="fieldset">
                      <div className="form-group">
                        <div className="form-tit">
                          <label htmlFor="login_id">아이디</label>
                        </div>
                        <div className="form-conts">
                          <input
                            type="text"
                            id="login_id"
                            className="form-control"
                            autoComplete="off"
                            placeholder="영문 소문자"
                            onChange={e => {
                              controller.valueObjChange('id', e.target.value);
                            }}
                            onKeyDown={e => {
                              if (e.key === 'Enter') {
                                controller.fnLogin();
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="form-tit">
                          <label htmlFor="login_pw">비밀번호</label>
                        </div>
                        <div className="form-conts btn-ico-wrap">
                          <input
                            type={passwordVisible ? 'text' : 'password'}
                            id="login_pw"
                            className="form-control"
                            autoComplete="off"
                            placeholder="영문, 숫자, 특수문자를 포함하여 8자 이상 20자 이내"
                            onChange={e => {
                              controller.valueObjChange(
                                'password',
                                e.target.value
                              );
                            }}
                            onKeyDown={e => {
                              if (e.key === 'Enter') {
                                controller.fnLogin();
                              }
                            }}
                          />
                          {loginMsgDp.length > 0 && (
                            <p
                              className="text-point"
                              dangerouslySetInnerHTML={{
                                __html: loginMsgDp,
                              }}
                            ></p>
                          )}
                          <button
                            type="button"
                            className="btn btn-ico ico-pw-visible md"
                            onMouseDown={() => togglePasswordVisibility(true)}
                            onMouseUp={() => togglePasswordVisibility(false)}
                            onMouseLeave={() => togglePasswordVisibility(false)}
                          >
                            <span className="sr-only">
                              입력한 비밀번호 보기
                            </span>
                          </button>
                        </div>
                      </div>
                      <div className="form-group">
                        <button
                          type="submit"
                          className="btn primary"
                          onClick={() => controller.fnLogin()}
                        >
                          로그인
                        </button>
                      </div>
                      <div className="form-group">
                        <ul className="link-group">
                          <li>
                            <Link
                              to="/member/findId"
                              className="btn md btn-txt"
                            >
                              아이디 찾기
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/member/findPassword"
                              className="btn md btn-txt"
                            >
                              비밀번호 찾기
                            </Link>
                          </li>
                          {/* <li>
                            <Link
                              to="/member/joinPage"
                              className="btn md btn-txt"
                            >
                              회원가입
                            </Link>
                          </li> */}
                        </ul>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;
